import fetch from "../../uilts/request.js";

export default {
    setStatus(data) {
        return fetch.post('/GoodsClassify/setStatus', data)
    }
}